<script>
import {routing, config} from '@/assets/js/config/base'
import {http, setBearer} from '@/api/headers'
import es from '@/assets/js/locale/vee.validate'
import {auth} from '@/assets/js/libs/sessions'
import {messages} from '@/assets/js/locale/messages'

export default {
  data: function () {
    return {
      httpRequest: {
        element: [],
        params: '',
        module: null
      },
      waitPlease: false
    }
  },
  methods: {
    get: function (httpRequest) {
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.get(routing[httpRequest.module] + httpRequest.params)
              .then(
                response => {
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  reject(error.response)
                }
              )
          }
        )
      })
    },
    getById: function (id, httpRequest) {
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.get(routing[httpRequest.module] + '/' + id + httpRequest.params)
              .then(
                response => {
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  reject(error.response)
                }
              )
          }
        )
      })
    },
    post: function (httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.post(routing[httpRequest.module] + httpRequest.params, httpRequest.element)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403) {
                    auth.logout()
                    let message = messages['403']
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = messages[error.response.status]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    put: function (id, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.put(routing[httpRequest.module] + '/' + id + httpRequest.params, httpRequest.element)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403) {
                    auth.logout()
                    let message = messages['403']
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = messages[error.response.status]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    delete: function (id, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.delete(routing[httpRequest.module] + '/' + id)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403) {
                    auth.logout()
                    let message = messages['403']
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = messages[error.response.status]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    formErrorHandler: function (data) {
      this.$store.commit('notificate', {
        title: 'CAMPOS REQUERIDOS',
        text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
        type: 'warn'
      })
      let messages = es.messages
      for (var field in data) {
        for (var rule in data[field]) {
          let msg = messages[rule]
          let fieldError = {
            field: field,
            msg: msg,
            rule: rule
          }
          this.$validator.errors.add(fieldError)
          this.$validator.errors.first(field + ':' + rule)
          setTimeout(() => {
            this.$validator.errors.clear()
          }, 3000)
        }
      }
    },
    upload: function (file, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
         setBearer().then(
           bearer => {
             this.XMLHttpReq(bearer, file, httpRequest)
              .then(
                response => {
                  this.$store.commit('ready')
                  this.$store.commit('notificate', {
                    title: 'ARCHIVO(S) SUBIDO(S)',
                    text: 'El o los archivos fueron subidos correctamente',
                    type: 'success'
                  })
                  resolve(response)
                }
              ).catch(
                error => {
                  this.$store.commit('ready')
                  if (error.status === 403) {
                    auth.logout()
                    let message = messages['403']
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = messages[error.status]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
           }
         )
      })
    },
    XMLHttpReq: function (jwtToken, file, httpRequest) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        let xhr = new XMLHttpRequest()
        let image = file.target.files[0]
        let name = file.target.name
        formData.append(name, image)
        xhr.open('post', config.api.url + '/' + routing[httpRequest.module] + '/' + httpRequest.params, true)
        xhr.setRequestHeader('Authorization', jwtToken)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(JSON.parse(xhr.response))
            } else {
              reject(xhr)
            }
          }
        }
        xhr.send(formData)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/api/request.vue